import { __awaiter, __extends, __generator } from "tslib";
import * as React from 'react';
import { connect } from 'react-redux';
import { appWscInstance } from '../../../_library/utils/app-ws-client';
import { createDebugLogger } from '../utils/app-utils';
import { getThreadId } from '../../domain/selectors/get-thread-id';
import { api } from '../utils/api-helpers';
import { domainAction } from '../../domain/domain-redux';
import { getLastThreadMessage } from '../../domain/selectors/get-last-thread-message';
import { ARBITRARY_ID_LAST_SENT_MESSAGE, DOMAIN_TYPE_ARBITRARY, WIDGET_ID_PLEASE_WAIT, } from '../../../consts';
import { remoteLog } from '../../../_library/utils/remote-log';
import { getIsOnlineStatus } from '../../domain/selectors/get-is-online';
/**
 * If we send message to server (user typing, or clicking on tile), we expect to get resposne
 * back (users own message, or goodbod response) withint this timeout.
 */
var WS_MESSAGE_RECEIVED_TIMEOUT = Number(process.env.WS_MESSAGE_RECEIVED_TIMEOUT) || 5000;
var CHECK_WS_INTERVAL = 5000;
var FETCH_MESSAGES_INTERVAL = 1500; // how often the rest fallback should fetch messages
var debug = createDebugLogger('RestFallback');
function getMessages(threadId, createdAfter) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api().getMessages(threadId, { createdAfter: createdAfter })];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
/**
 * Issues request to get messages from messages endpoint, if websocket connection is down
 */
var RestFallbackClass = /** @class */ (function (_super) {
    __extends(RestFallbackClass, _super);
    function RestFallbackClass() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false,
            isFetching: false,
        };
        _this.fetchMessagesRequest = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, threadId, dispatch, lastMessage, createdAfter, messages, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, threadId = _a.threadId, dispatch = _a.dispatch;
                        // skip if offline
                        if (!this.props.isOnline)
                            return [2 /*return*/];
                        if (!threadId)
                            return [2 /*return*/];
                        debug('fetchMessagesRequest: requested, threadId: ', threadId);
                        if (this.state.isFetching) {
                            debug('fetchMessagesRequest: already fetching');
                            return [2 /*return*/];
                        }
                        lastMessage = this.props.lastThreadMessage;
                        if (!lastMessage) {
                            return [2 /*return*/];
                        }
                        createdAfter = lastMessage.created && lastMessage.created instanceof Date
                            ? lastMessage.created.toISOString()
                            : String(lastMessage.created);
                        if (!createdAfter) {
                            debug('fetchMessagesRequest: no createdAfter message!');
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        this.setState({ isFetching: true });
                        debug("fetchMessagesRequest: fetching messages for thread ".concat(threadId, ", createdAfter: ").concat(createdAfter));
                        return [4 /*yield*/, getMessages(threadId, createdAfter)];
                    case 2:
                        messages = _b.sent();
                        dispatch(domainAction.mergeModelsPayload(messages));
                        this.setState({ isFetching: false });
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        this.setState({ isFetching: false });
                        debug('fetchMessagesRequest error', e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        /**
         * Returns false, if there is no response from server within grace period
         */
        _this.isResponseReceivedWithin = function (gracePeriod) {
            if (gracePeriod === void 0) { gracePeriod = 2000; }
            // skip check, if user has not sent any messages
            if (!_this.props.lastSubmittedMessageData)
                return true;
            // skip check, if we have not one valid message from server
            if (!_this.props.lastThreadMessage)
                return true;
            var userSentTimestamp = _this.props.lastSubmittedMessageData.timestamp;
            var lastMessageReceivedTime = new Date(_this.props.lastThreadMessage.created).getTime();
            debug("UserSentTimestamp: ".concat(new Date(userSentTimestamp).toLocaleTimeString(), ", lastMessageReceivedTime: ").concat(new Date(lastMessageReceivedTime).toLocaleTimeString()));
            if (lastMessageReceivedTime + gracePeriod < userSentTimestamp) {
                debug("User has sent message, but there is no message from server within ".concat(gracePeriod, "ms"));
                return false;
            }
            else {
                debug("isResponseReceivedWithin: true");
                return true;
            }
        };
        _this.checkWsConnectionStatus = function () {
            if (!_this.props.lastThreadMessage) {
                debug('checkWsConnectionStatus: no lastThreadMessage, skipping');
                return;
            }
            var isWsOpen = _this.wsc && _this.wsc.isOpen(); // this returns false positives - is true even if we have not a working connection
            var isWsOpenByMessageTimeout = _this.isResponseReceivedWithin(WS_MESSAGE_RECEIVED_TIMEOUT); // alternative check
            var isOpen = isWsOpen && isWsOpenByMessageTimeout;
            var msg = "isOpen: ".concat(isOpen, ", isWsOpen: ").concat(isWsOpen, ", isWsOpenByMessageTimeout: ").concat(isWsOpenByMessageTimeout);
            debug(msg);
            if (!isOpen) {
                remoteLog.debug("RestFallback: ".concat(msg), _this.props.threadId).then().catch();
                if (_this.fetchMessagesInterval) {
                    // restarting interval is needed, because it is more stable, sometimes interval reference is
                    // set, but no interval is running
                    clearInterval(_this.fetchMessagesInterval);
                }
                debug("checkWsConnectionStatus: websocket connection is down, starting periodic fetching of messages");
                _this.fetchMessagesRequest().then();
                _this.fetchMessagesInterval = setInterval(_this.fetchMessagesRequest, FETCH_MESSAGES_INTERVAL);
            }
            else {
                // Do not clear interval, because isWsOpenByMessageTimeout returns true after fallback delivers users message.
                // Instead, continue with rest fallback until user types new message (see componentDidUpdate)
                // This ensures we get (new) messages originating from server, even if user is not sending any messages
            }
            _this.setState({ isOpen: isOpen });
        };
        return _this;
    }
    RestFallbackClass.prototype.componentDidMount = function () {
        this.wsc = appWscInstance();
        if (this.wsc) {
            this.setState({ isOpen: this.wsc.isOpen() });
        }
        // monitor using interval
        debug('RestFallback mounted', "ws isOpen: ".concat(this.state.isOpen));
        this.wsCheckInterval = setInterval(this.checkWsConnectionStatus, CHECK_WS_INTERVAL);
    };
    RestFallbackClass.prototype.componentWillUnmount = function () {
        debug("RestFallback unmounted");
        clearInterval(this.wsCheckInterval);
        this.wsCheckInterval = undefined;
        clearInterval(this.fetchMessagesInterval);
        this.fetchMessagesInterval = undefined;
    };
    RestFallbackClass.prototype.render = function () {
        return null;
    };
    return RestFallbackClass;
}(React.Component));
var mapStateToProps = function (state) {
    var threadId = getThreadId(state);
    var filterFn = function (message) {
        if (message.id === WIDGET_ID_PLEASE_WAIT)
            return false; // ignore this message (can have future created date)
        return true;
    };
    var isOnline = getIsOnlineStatus(state);
    return {
        isOnline: isOnline,
        threadId: threadId,
        lastThreadMessage: getLastThreadMessage(state, filterFn)(threadId),
        lastSubmittedMessageData: state.domain[DOMAIN_TYPE_ARBITRARY][ARBITRARY_ID_LAST_SENT_MESSAGE],
    };
};
var mapDispatchToProps = function (dispatch, ownProps) { return ({
    dispatch: dispatch,
}); };
export var RestFallback = connect(mapStateToProps, mapDispatchToProps)(RestFallbackClass);
